import InfoPreview from "@common/controls/InfoPreview/component";
import { useI18n } from "@common/hooks/i18n";
import { type Account } from "@common/modules/account/types";
import React from "react";

type CryptoRecipientProps = {
  data: Account.Api.CryptoBeneficiaryData;
  currencyCode: string;
  style?: React.CSSProperties;
};
const CryptoRecipientPreview = (props: CryptoRecipientProps) => {
  const i18n = useI18n();
  return (
    <InfoPreview style={props.style}>
      <InfoPreview.Line label={i18n.currency} value={props.currencyCode} />
      <InfoPreview.Line label={i18n.walletAddress} value={props.data.walletAddress} />
    </InfoPreview>
  );
};
export default CryptoRecipientPreview;
